import { Box } from "@mui/material";
import styled from "styled-components";

export const BaseFormStyled = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 20px;
`